const ENV = 'PROD'; 
let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
const CONFIG = {
  DEV: {
    apiBase:    'https://api.dev.hav-g.in/',
    publicBase: 'https://public-zxhj2.dev.hav-g.in/',
    formBase:   'https://formv2s.dev.hav-g.in',
    token:      'Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d',
  },
  PROD: {
    apiBase:    'https://api.hav-g.in/',
    publicBase: 'https://public-jgfas325.hav-g.in/',
    formBase:   'https://form.traya.health',
    token:      'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90',
  },
};

const { apiBase, publicBase, formBase, token: AUTH_TOKEN } = CONFIG[ENV];
const AUTH_HEADERS = {
  'Content-Type': 'application/json',
  'Authorization': AUTH_TOKEN,
};

const VARIANT_DATA_MAP = new Map([
  ["46528923304114", { name: "For Advanced Dandruff",            one_liner: "Advanced Anti-Dandruff Solution for stubborn dandruff" }],
  ["47329496826034", { name: "For Dandruff",                     one_liner: "Anti-Dandruff Shampoo with proven actives" }],
  ["41645770309810", { name: "For Hair Regrowth",                one_liner: "Recap Serum with Hair Growth Actives" }],
  ["47329517568178", { name: "For Hair Regrowth",                one_liner: "Minoxidil 2% that prevents hormone led hair damage" }],
  ["47302891929778", { name: "For Hair Regrowth",                one_liner: "Minoxidil 5% that prevents hormone led hair damage" }],
  ["47301151064242", { name: "For Hair Hygiene",                 one_liner: "Defence Shampoo for pH balance (SLS Free)" }],
  ["44650256728242", { name: "For Hair Texture",                 one_liner: "Defence Conditioner for hydrated hair (SLS Free)" }],
  ["46466175008946", { name: "For Sleep",                        one_liner: "Nasal Ghrit for restful sleep" }],
  ["46528902496434", { name: "For Digestion",                    one_liner: "Gut Shuddi for constipation relief" }],
  ["46528906821810", { name: "For Hair Nutrition",               one_liner: "Hair Ras for hair nourishment" }],
  ["47303072710834", { name: "For Hairfall Control",             one_liner: "Hair Vitamin with natural hormone-blockers" }],
  ["46528920289458", { name: "For Metabolism",                   one_liner: "Health Tatva for improved energy" }],
  ["46531537273010", { name: "For Scalp Health",                 one_liner: "Scalp Oil with booster for scalp health" }],
  ["46530268987570", { name: "For Scalp Health",                 one_liner: "Scalp Oil with booster for stress" }],
  ["46531521872050", { name: "For Scalp Health",                 one_liner: "Scalp Oil with booster for hair growth" }],
  ["46530365751474", { name: "For Scalp Health",                 one_liner: "Scalp Oil with booster for dandruff control" }],
  ["46528963936434", { name: "For Digestion",                    one_liner: "Digest Boost for Gas and Bloating Relief" }],
  ["47302951403698", { name: "For Hair Nutrition",               one_liner: "Nourish Oil for adding shine to dull hair" }],
  ["47301148803250", { name: "For Hair Texture",                 one_liner: "Serum for Frizz-free, shiny hair" }],
  ["46465792704690", { name: "For Hair Nourishment",             one_liner: "Iron Santulan for deficiency triggered hair fall" }],
  ["47276517195954", { name: "For Stress",                       one_liner: "Calm Ras to improve stress and sleep" }],
  ["46465596719282", { name: "For Hair Regrowth",                one_liner: "Minoxidil 2% that prevents hormone led hair damage" }],
  ["46465512898738", { name: "For Hair Regrowth",                one_liner: "Minoxidil 5% that prevents hormone led hair damage" }],
  ["44422009323698", { name: "For Hair Hygiene",                 one_liner: "Defence Shampoo for pH balance (SLS Free)" }],
  ["47300731568306", { name: "For Hair Volume",                  one_liner: "Serum with proven Hair Actives" }],
  ["46466005598386", { name: "For Digestion",                    one_liner: "Consti Clear for improved digestion" }],
  ["47302757875890", { name: "For Stress, Metabolism & Digestion", one_liner: "Hair Ras 01 for hair nourishment" }],
  ["47301161091250", { name: "For Stress, Metabolism & Digestion", one_liner: "Hair Ras 02 for hair nourishment" }],
  ["46464896630962", { name: "For Stress, Metabolism & Digestion", one_liner: "Hair Ras 05 for hair nourishment" }],
  ["47301139169458", { name: "For Stress & Metabolism",          one_liner: "Hair Ras 06 for hair nourishment" }],
  ["46464745308338", { name: "For Stress",                       one_liner: "Hair Ras 09 for hair nourishment" }],
]);

// ============================================================
// DANDRUFF PRODUCT IDs (for plan tagging in checkout)
// ============================================================
const DANDRUFF_VARIANT_IDS = new Set([37681124081842, 42648509186226, 41899898011826]);

// ============================================================
// FUTURE KIT IMAGES MAP
// ============================================================
const FUTURE_KIT_IMAGES = {
  5:  { desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_3_f85dfd3e-2878-45c7-aad9-d67a6429ff7b.webp', mob: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_2_fed1e1e3-5163-43dc-bce4-070ebac97d40.webp' },
  8:  { desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_5.webp?v=1766991051',                         mob: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_4_b96d31a7-587c-489d-960a-a7e0b8b7e8eb.webp' },
  12: { desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_8.webp',                                      mob: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_7.webp' },
};

// ============================================================
// STATE (consolidated — no scattered globals)
// ============================================================
const STATE = {
  id:         null,
  f_name:     '',
  C_number:   '',
  C_email:    '',
  user_gender: '',
  caseId:     '',
  variantsIDs: [],
};

// ============================================================
// URL PARAMS (unified — replaces getUrlParameter + new URLSearchParams scattered across file)
// ============================================================
const URL_PARAMS = new URLSearchParams(window.location.search);
const getParam   = (key) => URL_PARAMS.get(key);

// ============================================================
// INIT
// ============================================================
(function init() {
  const urlSource = getParam('url_source');
  if (urlSource) localStorage.setItem('traya_path_name', urlSource);

  // Persist UTM params
  URL_PARAMS.forEach((value, key) => {
    if (key.startsWith('utm_') && value) {
      try { localStorage.setItem(key, value); } catch (e) {}
    }
  });

  // Resolve user ID
  const idFromUrl = getParam('id');
  if (idFromUrl) {
    localStorage.setItem('user-gender', 'male');
    localStorage.setItem('rid', idFromUrl);
  }
  STATE.id = localStorage.getItem('rid') || getCookie('syntheticId');

  // Handle missing ID
  if (!STATE.id) {
    if (window.location.pathname === '/pages/result4c') {
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href = 'https://form.traya.health/questions?cohort=1&source=ResultPage';
      return;
    }
    togglePageVisibility(false);
  } else {
    setotherCookie('syntheticId', STATE.id, 30, '.traya.health');
    togglePageVisibility(true);
    scheduleCartAttributeUpdate();
  }

  window.addEventListener('DOMContentLoaded', onDOMReady);
})();

function onDOMReady() {
  const atcButtons = document.querySelectorAll('#add-to-cart-result-page');
  atcButtons.forEach(button => {
    button.disabled = true;
    button.addEventListener('click', handleATCClick.bind(null, button));
  });

  // Tab switching
  document.querySelectorAll('.f-b-main-li').forEach(item => {
    item.addEventListener('click', function () {
      triggerTabAction(this.getAttribute('data-targets'));
    });
  });

  const endpoint = `${apiBase}dgReport/male/v4?id=`;
  getMaleResult(endpoint, STATE.id);
}

// ============================================================
// ATC BUTTON CLICK
// ============================================================
function handleATCClick(button) {
  button.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
  button.classList.add('loader-added');
  button.disabled = true;

  Shopify.analytics.publish('result_add_to_cart', { gender: 'Male' });

  setTimeout(() => {
    window.location.href = window.appliedReferralCode
      ? `/checkout?discount=${window.appliedReferralCode}`
      : '/checkout';
  }, 100);

  // Restore button state (fallback if redirect fails)
  setTimeout(() => {
    button.disabled = false;
    button.classList.remove('loader-added');
    button.style.textTransform = 'capitalize';
    button.innerHTML = `<span class="Rmoney_buy mr-1 mr-md-5">Buy Now</span>`;
    button.style.color = '#000';
  }, 1500);
}

// ============================================================
// PAGE VISIBILITY TOGGLE (replaces 8 separate if-blocks)
// ============================================================
function togglePageVisibility(hasResult) {
  const show = hasResult ? 'block' : 'none';
  const hide = hasResult ? 'none' : 'block';

  const selectors = {
    '[data-formPage]':   hasResult ? 'none'  : 'block',
    '[data-resultPage]': hasResult ? 'block' : 'none',
    '[data-resultbtn]':  hasResult ? 'block' : 'none',
    '[data-notResult]':  hasResult ? 'none'  : 'block',
    '[data-result]':     hasResult ? 'block' : 'none',
  };

  Object.entries(selectors).forEach(([selector, display]) => {
    document.querySelectorAll(selector).forEach(el => { el.style.display = display; });
  });
}

// ============================================================
// FETCH RESULT
// ============================================================
async function getMaleResult(endpoint, id) {
  document.body.style.overflow = 'hidden';
  let _fetchedCaseId = '';
  try {
    const response = await fetch(`${endpoint}${id}&isWebsite=true`, {
      headers: { Authorization: AUTH_TOKEN },
    });
    const data = await response.json();

    const caseId      = String(data?.User_Analysis?.case_id ?? '').trim();
    _fetchedCaseId = caseId;
    tagClarityCaseId(caseId);
    const genetic     = data?.Recommendations?.Genetic;
    const stage       = data?.currentStage?.stage;
    const queryString = window.location.search;

    console.log('Fetched caseId:', caseId);

    // Redirect to result4b for genetic + advanced stages
    if (genetic === 'Yes' && ['Stage-2', 'Stage-3', 'Stage-4', 'Stage-5'].includes(stage)) {
      window.location.href = `/pages/result4b${queryString}`;
      return;
    }

    rootCause(data?.root_causes);
    resultMonthKit(data);
    trackMetaEvent(data.User_Analysis, "Viewed Content");
    ShowContent(data);
    displayUserDetails(data);
    successRateDataFetch(data);
    displayStageSection(data);
    sectionRealStories(data);
    headerLanguageSelector();
  } catch (error) {
    console.error('getMaleResult error:', error);
    document.body.style.overflow = 'unset';
  } finally {
    await clearCart(_fetchedCaseId);
    if (STATE.variantsIDs.length > 0) checkout(); // Guard: only checkout if items exist
    // setTimeout(() => {
    //   if (trayaProcessingAnimation) {
    //     trayaProcessingAnimation.style.display = 'none';
    //   }
    //   document.body.style.overflow = 'unset';
    // }, 1000);
  }
}

// ============================================================
// CART — CLEAR
// ============================================================
async function clearCart(caseId) {
  var _id = caseId || STATE.caseId || localStorage.getItem('caseId') || '';
  try {
    // Fetch cart state first to avoid calling clear.js on an already-empty cart.
    // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
    const cartState = await fetch('/cart.js').then(r => r.json());
    if ((cartState.item_count || 0) === 0) return;

    const res    = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sections: 'cart-drawer' }),
    });
    const result = await res.json();
    CartDrawerUpdate(document.querySelector('cart-drawer'), result.sections['cart-drawer'], false, 0);
  } catch (error) {
    console.error('clearCart error:', error);
  }
}

// ============================================================
// CART — CHECKOUT / ADD ITEMS
// ============================================================
function checkout() {
  localStorage.setItem('user__gender', STATE.user_gender);
  localStorage.setItem('caseId', STATE.caseId);

  // Tag items with plan type
  STATE.variantsIDs.forEach(item => {
    item.properties = { Plan: DANDRUFF_VARIANT_IDS.has(item.id) ? 'Dandruff' : 'Auto' };
  });

  const syntheticId = getParam('id') || getParam('syntheticId') || localStorage.getItem('syntheticId') || 'default-id';

  const formData = {
    items: STATE.variantsIDs,
    sections: 'cart-drawer',
    attributes: {
      first_name:   STATE.f_name,
      phone:        STATE.C_number,
      email:        STATE.C_email,
      caseid:       STATE.caseId,
      user__gender: STATE.user_gender,
      syntheticId,
    },
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  })
    .then(res => {
      localStorage.setItem('User_location', 'cart');
      return res.json();
    })
    .then(result => {
      CartDrawerUpdate(document.querySelector('cart-drawer'), result.sections['cart-drawer']);
    })
    .catch(err => console.error('checkout error:', err))
    .finally(() => {
      updateCartDrawer();
      cartData();
      const btn = document.querySelector('#add-to-cart-result-page');
      if (btn) btn.disabled = false;
    });
}

// ============================================================
// CART — UPDATE DRAWER (deduplicate quantities)
// ============================================================
function updateCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};
      cart.items.forEach(item => {
        if (item.quantity === 2) updates[item.key] = 1;
      });

      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then(res => res.json())
          .then(() => refreshCartUI())
          .catch(err => console.error('updateCartDrawer error:', err));
      } else {
        refreshCartUI();
      }
    });
}

// ============================================================
// CART — REFRESH UI SECTIONS
// ============================================================
function refreshCartUI() {
  fetch('/?sections=cart-icon-bubble')
    .then(res => res.json())
    .then(data => {
      const el = document.getElementById('cart-icon-bubble');
      if (el && data['cart-icon-bubble']) el.innerHTML = data['cart-icon-bubble'];
    });

  fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(data => {
      const html      = data['cart-drawer'];
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && html) {
        cartDrawer.outerHTML = html;
        setTimeout(() => bindCartDrawerEvents(), 50);
        document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity')
          .forEach(el => { el.style.display = 'none'; });
      }
    })
    .catch(err => console.error('refreshCartUI error:', err));
}

function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}

function displayUserDetails(data) {
  // ── Extract user data from API response ──────────────────
  const resp = Object.assign({}, data.User_Analysis, data.Recommendations);

  // Populate STATE (matches the STATE object from the main optimized file)
  STATE.f_name     = resp.first_name;
  STATE.C_number   = resp.phone;
  STATE.C_email    = resp.email;
  STATE.caseId     = resp.case_id;
  STATE.user_gender = resp.gender === 'M' ? 'Male' : resp.gender;

  setCookie('user_phone', STATE.C_number, 30);
  localStorage.setItem('caseId', STATE.caseId);
  var gmpNote = document.querySelector('.gmp-certified-strip');
  if (gmpNote) gmpNote.classList.remove('d-none');
  var stickyBtn = document.getElementById('sticky-btn');
  if (stickyBtn) stickyBtn.style.boxShadow = 'none';

  // ── Stage 6 layout override ───────────────────────────────
  const isStage6 = resp.gender === 'M' && resp.stage === 'Stage-6';

  if (isStage6) {
    const body = document.querySelector('body.result4');
    const main = document.querySelector('body.result4 #MainContent');
    if (body) body.style.width = '100%';
    if (main) main.style.padding = '0';
  }

  // ── Show/hide page sections based on stage ────────────────
  // All selectors that toggle with d-none on Stage-6
  const toggleSelectors = [
    '.test-result',
    '.kit-container',
    '.section-coach.container',
    '.timeline--container',
    '.custom-price-section',
    '.eligibility-check--section',
    '.aldrich-faq',
    '.sticky-btn',
  ];

  toggleSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.toggle('d-none', isStage6);
    });
  });

  // transplant-stage-six is the inverse: show on Stage-6, remove otherwise
  document.querySelectorAll('.transplant-stage-six').forEach(el => {
    if (isStage6) {
      el.classList.remove('d-none');
    } else {
      el.remove();
    }
  });
  // ── Stage label in UI ─────────────────────────────────────
  const stageEl    = document.querySelector('#stage');
  const stageMatch = resp.stage?.match(/^Stage-(\d)$/);
  if (stageEl && stageMatch) {
    stageEl.innerHTML = `Stage ${stageMatch[1]} Hair Fall`;
  }

  // ── Hide processing animation ─────────────────────────────
  setTimeout(() => {
    const trayaProcessingAnimation = document.getElementById('traya-processing-animation');
    if (trayaProcessingAnimation) trayaProcessingAnimation.style.display = 'none';
    document.body.style.overflow = 'unset';
  }, 1000);
  
  sectionMonthsExpectation(variantKey = 'monthExpectation', data);
  applyOneMonthDiscount(data);

  console.log(data.stage1Cohort, "stage1Cohort");
  const timelineBoxElement = document.querySelector('.timeline-box');
  const startSeeingResultsElement = document.querySelector('.start-seeing-results-show');
  const monthsUpdateExpectation = document.querySelector('.month-expectation--heading .weeks-update');
  const milestoneGoalElement = document.querySelector('.month-milestone-badge');
  if(data.stage1Cohort?.includes('dandruff_stop_hairfall') || data.stage1Cohort?.includes('no_dandruff_stop_hairfall')){
    if(timelineBoxElement) timelineBoxElement.classList.remove('d-none');
    if(milestoneGoalElement) milestoneGoalElement.classList.remove('d-none');
  } else {
    if(startSeeingResultsElement) startSeeingResultsElement.classList.remove('d-none');
    if(monthsUpdateExpectation) monthsUpdateExpectation.innerHTML = '5 Months';
  }
}

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

function ShowContent(data) {
  // ── Extract core fields ───────────────────────────────────
  const userAnalysis      = data.User_Analysis;
  const recommendations   = data.Recommendations;
  const resp              = Object.assign({}, userAnalysis, recommendations);

  const userStage         = resp.stage;
  const genetics          = resp.Genetic;
  const illness           = resp.experienced_in_one_year ?? [];
  const stageDescription  = data.stageWiseDescription?.english ?? '';
  const maxMonth          = recommendations.Max_months;
  const stageImage        = data?.currentStage?.imgUrl;
  const urlSource         = getParam('url_source'); // uses getParam() from main optimized file

  // ── Growth bar & treated count ────────────────────────────
  if (data.growthPossibilityBar) {
    document.querySelector('.cstm-growthPossibilityBar')?.style.setProperty('display', 'block');
  }

  const treatedCountDOM   = document.querySelector('.customer-based-profile');
  const treatmentDuration = document.querySelector('.traetment-duration');
  if (treatedCountDOM)   treatedCountDOM.innerText   = data.treatedCXCount?.description ?? '';
  if (treatmentDuration) treatmentDuration.innerText = `${maxMonth} Months`;

  FutureKitRoutine(maxMonth);

  // ── Batch text-fill for simple selectors ─────────────────
  // [ selector, text ]
  const stageLabel = userStage?.replace(/-/g, ' ') ?? '';
  const textFills  = [
    ['[data-user-name]', resp.first_name],
    ['#name1',           resp.first_name],
    ['#name3',           resp.first_name],
    ['#stage1',          stageLabel],
    ['#stage3',          stageLabel],
    ['#typeOfLoss3',     resp.Type_of_hair_loss],
  ];

  textFills.forEach(([selector, text]) => {
    document.querySelectorAll(selector).forEach(el => { el.innerHTML = text; });
  });

  // ── typeOfLoss (simple cases before illness logic) ────────
  const simpleStageOverride = userStage === 'Coin Size Patch' || userStage === 'Heavy Hair Fall';
  const typeOfLossText      = simpleStageOverride ? userStage : resp.Type_of_hair_loss;
  setAll('#typeOfLoss', typeOfLossText);

  // ── Stage description ─────────────────────────────────────
  // const descText = userStage === 'Heavy Hair Fall'
  //   ? "Heavy hair fall is caused when your body has been through a major shock. This type of hair fall is completely reversible and we're confident you'll see results within 3-6 months."
  //   : stageDescription;
  // setAll('#stageDescription', descText);

  // ── Illness / typeOfLoss override logic ───────────────────
  const isHeavyFallStage = userStage === 'Heavy Hair Fall Across The Head' || userStage === 'Heavy Hair Fall';

  if (illness.length) {
    const hasSevereIllness = illness.includes('Severe Illness (Dengue, Malaria, Typhoid or Covid)');

    if (isHeavyFallStage) {
      if (hasSevereIllness) {
        // Severe illness present — always TE regardless of genetics
        setAll('#typeOfLoss', 'Telogen Effluvium');

      } else if (genetics === 'Yes') {
        setAll('#typeOfLoss', 'Male Pattern Hair Fall');

      } else if (genetics === 'No') {
        setAll('#typeOfLoss', 'Telogen Effluvium');
        setAll('#stage', stageLabel);

      }
    } else if (userStage === 'Coin Size Patch') {
      setAll('#typeOfLoss', 'Coin Size Patches');

    } else {
      setAll('#typeOfLoss', resp.Type_of_hair_loss);
    }
  }

  // ── Dandruff section ──────────────────────────────────────
  if (userStage !== 'Stage-6' && userAnalysis.dandruff_response === 'Yes, heavy dandruff that sticks to the scalp') {
    const el = document.querySelector('.male_pcos_causing_main');
    if (el) el.style.display = 'block';
  }

  // ── Stage-6 visibility overrides ─────────────────────────
  if (userStage === 'Stage-6') {
    ['.male-treatment-plan', '.aldrich-faq', '.future-kit-routine'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) el.style.display = 'none';
    });
  } else {
    const doctorEl = document.querySelector('.stage1-doctors');
    if (doctorEl) doctorEl.style.display = 'block';
  }

  // ── Stage images ──────────────────────────────────────────
  const frontAPIImage          = data?.currentStage?.frontImageURL;
  const topAPIImage            = data?.currentStage?.topImageURL;
  const frontTopContainer      = document.querySelector('.front-top-images-container');
  const hasFrontTopImages      = frontTopContainer && topAPIImage && frontAPIImage;

  if (urlSource === 'questionsV5_FC' && hasFrontTopImages) {
    frontTopContainer.classList.remove('d-none');
    document.querySelector('.repostSelectedStage')?.classList.add('d-none');
    frontTopContainer.querySelector('img.frontstage-image')?.setAttribute('src', frontAPIImage);
    frontTopContainer.querySelector('img.topstage-image')?.setAttribute('src', topAPIImage);
  } else {
    // Fallback: use stageImage for all .repostSelectedStage elements
    applyStageImage(stageImage);
  }

  // ── Diagnoses image ───────────────────────────────────────
  const diagImg = document.querySelector('.diagnoses-result > img');
  if (diagImg) diagImg.style.display = 'none';

  // ── #ourdia tabs ──────────────────────────────────────────
  const ourdia = document.querySelector('#ourdia');
  if (ourdia) {
    ourdia.querySelectorAll('li').forEach(li => { li.style.display = 'none'; });
    ourdia.querySelectorAll('a').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const tabId   = this.getAttribute('data-id');
        const panes   = document.querySelectorAll('.tab-pane');
        const navLinks = document.querySelectorAll('.nav-item.nav-link');

        panes.forEach(p => p.classList.remove('active', 'show'));
        navLinks.forEach(l => l.classList.remove('active'));

        document.querySelector(`#nav-tabContent #${tabId}`)?.classList.add('active', 'show');
        document.querySelector(`#nav-tab #${tabId}-tab`)?.classList.add('active');
      });
    });
  }

  // ── Stage names ───────────────────────────────────────────
  document.querySelectorAll('.stages-name').forEach(el => { el.style.display = 'none'; });

  // Final pass: ensure .repostSelectedStage images are set
  applyStageImage(stageImage);

  // ── ATC buttons — set user attributes ────────────────────
  document.querySelectorAll('#add-to-cart-result-page').forEach(btn => {
    btn.setAttribute('user-mobile', resp.phone);
    btn.setAttribute('user-email',  resp.email);
  });

  // ── ATC buttons — track checkout click ───────────────────
  const syntheticId = getParam('id') || 'default-id';
  document.querySelectorAll('#add-to-cart-result-page').forEach(btn => {
    btn.addEventListener('click', () => {
      window.umami?.track('checkout_initiated', { syntheticId });
      trackMetaEvent(data.User_Analysis, "Expand Benefits");
    });
  });
}

// ── Helpers ───────────────────────────────────────────────────

/** Set innerHTML on all matching elements */
function setAll(selector, text) {
  document.querySelectorAll(selector).forEach(el => { el.innerHTML = text; });
}

/** Set stageImage src on all .repostSelectedStage > img elements */
function applyStageImage(stageImage) {
  if (!stageImage) return;
  document.querySelectorAll('.repostSelectedStage').forEach(stage => {
    const img = stage.querySelector('img');
    if (img) img.setAttribute('src', stageImage);
  });
}

function successRateDataFetch(data) {
  const trigger = document.querySelector('.results-ui-update');
  const cliniclStudyNote = document.querySelectorAll('.clinical-study-note');
  const popup = document.getElementById('successrate-popup');
  const closeBtn = popup?.querySelector('.successrate-close');
  const contentBox = document.getElementById(
    'successrate--popup-content-placeholder'
  );
  const normalResultProgress = document.querySelector('.cstm-growthPossibilityBar.progress')
  const geneticAnswer = data?.Recommendations?.Genetic;
  const stage = data?.currentStage?.stage;
  const allowedStages = ["Stage-1", "Stage-2", "Stage-3", "Stage-4"];
  trigger?.classList.remove('d-none');
  cliniclStudyNote.forEach(el => { el.classList.remove('d-none');});
  normalResultProgress?.classList.add('d-md-block')
  if (!trigger || !popup || !contentBox || !closeBtn) return;

  let cachedHTML = '';
  let isReady = false;

  // 1️⃣ PREFETCH ON PAGE LOAD
  async function prefetchSuccessRatePage() {
    try {
      const res = await fetch('/pages/93-success-rate');
      if (!res.ok) throw new Error('Fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const pageContent =
        doc.querySelector('.page-width') ||
        doc.querySelector('main') ||
        doc.body;

      cachedHTML = pageContent.innerHTML;
      contentBox.innerHTML = cachedHTML;
      isReady = true;

      console.log('✅ Success rate page prefetched');
    } catch (err) {
      console.error('Prefetch failed:', err);
      contentBox.innerHTML =
        '<p>Unable to load content. Please refresh.</p>';
    }
  }

  // 2️⃣ OPEN POPUP (NO FETCH HERE)
  function openPopup() {
    if (!isReady) return; // safety
    popup.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  // 3️⃣ CLOSE POPUP
  function closePopup() {
    popup.classList.remove('show');
    document.body.style.overflow = '';
  }

  // Bind events
  trigger.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  // 🔥 IMPORTANT: prefetch immediately
  prefetchSuccessRatePage();
}

// ============================================================
// PRODUCT KIT — BUILD & RENDER
// ============================================================
function resultMonthKit(data) {
  const productData  = data.product_Ids;
  const caseProdId   = data?.User_Analysis?.case_id;
  const containerDiv = document.querySelector('.result-product-kit-wrapper');
  if (!containerDiv || !productData?.length) return;
  const productIdsArray = productData.map(p => p.product_id);
  const header = document.createElement('h2');
  header.classList.add('kit-header', 'section-heading-font');
  header.innerText = 'Start your journey with just 1 month kit';
  containerDiv.appendChild(header);

  if (window.innerWidth <= 767) containerDiv.classList.remove('container');

  const newSection = document.createElement('section');
  newSection.classList.add('shopify-kit-section');

  const hasGuestForm = !!getCookie('GuestForm_id');

  productData.forEach(each => {
    const variant       = VARIANT_DATA_MAP.get(each.product_id);
    const displayName   = variant?.name    ?? each.name;
    const displayLiner  = variant?.one_liner ?? each.oneLiner;

    // Tags
    const tagsHTML = each.tag.tagKeyArray
      .map(tag => `<p class="tag-title">${tag}</p>`)
      .join('');

    // Ayurveda badge logic
    const isAyurveda   = ['Ayurveda', 'ayurveda'].includes(each.type);
    const caseMatches  = caseProdId && /^[Def15679]/i.test(caseProdId);
    const showAyurveda = isAyurveda && caseMatches && !each.tag.customTag.showTag;

    const productDiv = document.createElement('div');
    productDiv.classList.add('kit-card-container');
    productDiv.dataset.productId = each.product_id;
    productDiv.innerHTML = `
      <div class="kit-card">
        <div class="box-separator-line">
          <div class="product-imge">
            <img src="${each.image_url.singleImage}" width="80" height="80" loading="lazy" />
          </div>
          <div class="product-description">
            <div class="prod-heading">
              <p class="prod-title">${displayName}</p>
              ${showAyurveda ? `
                <p class="recommended-product--type d-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path d="M1.24988 0.210509C1.26029 0.174453 1.27824 0.140656 1.30271 0.11105C1.32718 0.0814442 1.35769 0.0566105 1.3925 0.0379673C1.4273 0.0193241 1.46572 0.00723524 1.50555 0.0023961C1.54539 -0.00244303 1.58586 6.42699e-05 1.62465 0.00976677L1.62997 0.0111106C1.69925 0.0321174 2.33272 0.40002 3.25127 0.805552C4.42211 1.3223 5.97933 1.98564 6.58972 2.98936C7.51237 4.50645 7.20917 5.72395 5.69112 6.61242L6.31408 7.6368C6.33176 7.66429 6.34334 7.6948 6.34814 7.72651C6.35294 7.75822 6.35086 7.79051 6.34203 7.82147C6.3332 7.85242 6.31778 7.88143 6.2967 7.90677C6.27562 7.9321 6.2493 7.95327 6.21929 7.96901C6.18927 7.98475 6.15617 7.99474 6.12193 7.99842C6.08769 8.00209 6.05301 7.99936 6.01992 7.99039C5.98683 7.98141 5.95602 7.96638 5.92928 7.94617C5.90254 7.92596 5.88043 7.90098 5.86424 7.87271L5.24116 6.84832C3.63897 7.5985 2.36004 7.21184 1.43739 5.69474C0.3473 3.904 1.21228 0.36059 1.24988 0.210509ZM2.1515 5.42446C2.92413 6.69464 3.63062 6.98526 4.94968 6.36999L4.37037 5.41739L3.29793 5.27562C3.26386 5.27171 3.23096 5.26153 3.20117 5.24567C3.17137 5.22982 3.14527 5.20861 3.1244 5.18328C3.10352 5.15795 3.08829 5.12902 3.07959 5.09816C3.07088 5.0673 3.06887 5.03513 3.07369 5.00355C3.07851 4.97196 3.09006 4.94158 3.10765 4.91419C3.12524 4.88679 3.14853 4.86292 3.17616 4.84398C3.20379 4.82504 3.23519 4.81141 3.26856 4.80387C3.30192 4.79634 3.33656 4.79506 3.37046 4.8001L4.04927 4.88997L3.42245 3.8594C3.3915 3.80414 3.38487 3.73987 3.40395 3.68016C3.42303 3.62044 3.46633 3.56995 3.52471 3.53934C3.5831 3.50873 3.652 3.5004 3.71687 3.5161C3.78174 3.5318 3.83752 3.57031 3.87241 3.6235L5.39941 6.1342C5.84864 5.87044 6.33209 5.71058 6.5254 5.3765C6.86861 4.7828 6.64194 3.93949 6.14761 3.12663C5.58751 2.20548 4.04069 1.77613 2.91748 1.29556C2.42508 1.08471 2.03496 0.732419 1.75957 0.63772C1.67845 1.03325 1.28398 1.87274 1.23622 2.6865C1.17735 3.68405 1.70734 4.69462 2.15114 5.42446H2.1515Z" fill="#2D8A5D"/>
                  </svg>
                  <span>${each.type}</span>
                </p>` : ''}
            </div>
            ${each.tag.customTag.showTag
              ? `<div class="formulation-custom-tag">MADE SPECIALLY FOR YOU</div>`
              : ''}
            <div><p class="prod-details">${displayLiner}</p></div>
            <div>
              <p class="prod-price">
                ${each.originalPrice
                  ? `<del>₹${Math.floor(each.originalPrice)}</del> ₹${Math.floor(each.price)}`
                  : `₹${Math.floor(each.price)}`}
              </p>
            </div>
          </div>
          <div class="arrow">
            <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black"/>
            </svg>
          </div>
        </div>
        <hr class="block-line-separator d-none">
        <div class="tags tag-container d-none">
          <img src="${each.tag.icon}" alt="${each.tag.title}" class="d-none tag-icon">
          ${tagsHTML}
        </div>
      </div>
    `;

    newSection.appendChild(productDiv);

    // Accumulate cart items
    const cartItem = { id: each.product_id, quantity: 1 };
    if (hasGuestForm) cartItem.properties = { _result_id: STATE.id };
    STATE.variantsIDs.push(cartItem);
  });

  containerDiv.appendChild(newSection);
  addProductCardClickHandlers(productIdsArray);
}

// ============================================================
// PRODUCT POPUP
// ============================================================
function addProductCardClickHandlers(productIdsArray) {
  document.querySelectorAll('.shopify-kit-section .kit-card-container').forEach(kit => {
    kit.addEventListener('click', function (e) {
      showProductDetails(e.currentTarget.getAttribute('data-product-id'), 'english', productIdsArray);
    });
  });
}

function showProductDetails(productId, language, productIdsArray) {
  if (!productId) { console.error('Product ID is undefined'); return; }
  createProductPopup(productId, productIdsArray);
}

function createProductPopup(productId, productIdsArray) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  if (!popup || !overlay || !popupContentPlaceholder) return;
  const idsToSend = productIdsArray && productIdsArray.length
    ? productIdsArray
    : [productId];
  const encrypted = encryptProductIds(idsToSend);
  let iframeUrl = '';
  // const caseId = String(response?.User_Analysis?.case_id).trim();
  // if (!caseId) return;
  const firstChar = STATE.caseId.charAt(0);
  const variationUsers = ['d', 'e', 'f', '1', '5', '6', '7', '9'];
  const isVariationUser = variationUsers.includes(firstChar);
  iframeUrl = `${formBase}/product-drawerv4/${productId}?products=${encrypted}&lang=en`;

  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;

  // popupContentPlaceholder.innerHTML = `
  //   <iframe src="${formBase}/product-drawerv2/${productId}" frameborder="0" width="100%" height="100%"></iframe>
  // `;

  popup.style[isMobileDevice() ? 'bottom' : 'right'] = '0';
  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';

  // Use { once: true } so listeners don't stack on repeated opens
  document.querySelector('#product-popup #close-popup')?.addEventListener('click', closeProductPopup, { once: true });
  overlay.addEventListener('click', closeProductPopup, { once: true });
}

function closeProductPopup() {
  const popup   = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  if (!popup || !overlay) return;

  popup.style[isMobileDevice() ? 'bottom' : 'right'] = '-100%';
  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

function isMobileDevice() {
  return window.innerWidth <= 767;
}

// ============================================================
// ROOT CAUSE SECTION
// ============================================================
function rootCause(response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause  ?? [];
  const allCauses        = [...primaryRootCause, ...defaultRootCause];
  if (!allCauses.length) return;

  // ── Target the existing wrapper from your HTML ────────────
  const grid    = document.getElementById('rootCauseGrid');
  const descText = document.getElementById('causeDescText');
  if (!grid || !descText) return;

  // ── URL param for "Primary" tag visibility ────────────────
  const rootcauseFromURL = getParam('rootcause');
  const primaryTitle     = primaryRootCause[0]?.title?.toLowerCase();
  const showPrimaryTag   = rootcauseFromURL && primaryTitle && rootcauseFromURL === primaryTitle;

  // ── Build cards and inject into existing #rootCauseGrid ───
  grid.innerHTML = allCauses.map((item, index) => {
    const isPrimary  = index === 0 && primaryRootCause.length > 0;
    const isActive   = index === 0 ? 'active' : '';
    const primaryTag = isPrimary
      ? `<span class="cause-primary-tag${showPrimaryTag ? '' : ' d-none'}">Primary</span>`
      : '';

    return `
      <div class="cause-card ${isActive}" data-index="${index}" data-cause="${item.title.toLowerCase().replace(/ /g, '-')}">
        <div class="cause-icon">
          <img src="${item.details?.icon ?? ''}" alt="${item.title}" width="24" height="24" loading="lazy" />
        </div>
        <span class="cause-label">${item.title}</span>
        ${primaryTag}
      </div>`;
  }).join('');

  // ── Set first description ─────────────────────────────────
  descText.textContent = allCauses[0]?.details?.description?.english ?? '';

  // ── Click handlers ────────────────────────────────────────
  const cards = grid.querySelectorAll('.cause-card');
  cards.forEach(card => {
    card.addEventListener('click', () => {
      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      const idx = parseInt(card.dataset.index, 10);
      descText.textContent = allCauses[idx]?.details?.description?.english ?? '';
    });
  });
}
// ============================================================
// STAGE DATA — keyed by cohort, not stage
// ============================================================
const STAGE_DATA = {
  stopHairfallDandruff: {
    customerName: "Rohan",
    images: [
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_368df322-33e7-4c9d-b787-1802e7414608.webp?v=1771497484", label: "Dandruff Prone" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_500cc03c-8d6f-432d-80ed-ad8a1ca8ae25.webp?v=1771497484",   label: "Clear Scalp" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_2_5d71adab-b3a0-4bb3-9514-655b8f8e476d.webp?v=1771497484", label: "Regrowth" }
    ]
  },
  stopHairfallNoDandruff: {
    customerName: "Vikram",
    images: [
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/vikram_1.webp?v=1771573790", label: "Initial Stage" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/vikram_2.webp?v=1771573809", label: "Strengthening" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/vikram_3.webp?v=1771573820", label: "Regrowth" }
    ]
  },
  regrowthDandruff: {
    customerName: "Rohan",
    images: [
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_368df322-33e7-4c9d-b787-1802e7414608.webp?v=1771497484", label: "Dandruff Prone" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_500cc03c-8d6f-432d-80ed-ad8a1ca8ae25.webp?v=1771497484",   label: "Clear Scalp" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_2_5d71adab-b3a0-4bb3-9514-655b8f8e476d.webp?v=1771497484", label: "Regrowth" }
    ]
  },
  regrowthNoDandruff: {
    customerName: "Vikram",
    images: [
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/vikram_1.webp?v=1771573790", label: "Initial Stage" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/vikram_2.webp?v=1771573809", label: "Clear Scalp" },
      { url: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/vikram_3.webp?v=1771573820", label: "Regrowth" }
    ]
  }
};

function displayStageSection(response) {
  const container = document.getElementById('stageContainer');
  if (!container) return;

  // ── Cohort detection ──────────────────────────────────────
  const rawCohort          = response?.stage1Cohort ?? [];
  const cohort             = Array.isArray(rawCohort) ? rawCohort : [rawCohort];
  const isHairfallDandruff  = cohort.includes('dandruff_stop_hairfall');
  const isRegrowDandruff    = cohort.includes('dandruff_regrow');
  const isHairfallNoDandruff = cohort.includes('no_dandruff_stop_hairfall');
  const isRegrowNoDandruff  = cohort.includes('no_dandruff_regrow');

  // ── Pick correct dataset ──────────────────────────────────
  const stageData = isHairfallDandruff  ? STAGE_DATA.stopHairfallDandruff
                  : isRegrowDandruff    ? STAGE_DATA.regrowthDandruff
                  : isHairfallNoDandruff ? STAGE_DATA.stopHairfallNoDandruff
                  : isRegrowNoDandruff  ? STAGE_DATA.regrowthNoDandruff
                  : null;

  // ── FAQ visibility (dandruff cohorts only) ────────────────
  const isDandruff = isHairfallDandruff || isRegrowDandruff;
  const firstFaq   = document.querySelector('.faq-question-answer:nth-child(2)');
  if (firstFaq) firstFaq.style.display = isDandruff ? 'block' : 'none';

  console.log('stage1Cohort:', cohort, '→ showing:', stageData?.customerName ?? 'none');

  container.innerHTML = '';

  if (!stageData?.images?.length) {
    container.classList.add('d-none');
    return;
  }

  container.classList.remove('d-none');

  // ── Heading ───────────────────────────────────────────────
  container.innerHTML = `
    <p class="custome-stage-heading">Here Is ${stageData.customerName},</p>
    <p class="custome-stage-subheading">who matches your profile</p>
  `;

  // ── Scrollable image strip ────────────────────────────────
  const imageWrapper = document.createElement('div');
  imageWrapper.className = 'stage-image-wrapper';
  stageData.images.forEach((item, index) => {
    const isLast = index === stageData.images.length - 1;
    const monthLabel = isLast ? 5 : index + 1;
    const card = document.createElement('div');
    card.className = 'stage-image-card';
    card.innerHTML = `
      <img
        src="${item.url}"
        alt="Month ${index + 1} - ${item.label}"
        class="scrollable-stage-image"
        loading="lazy"
      />
      <div class="stage-image-caption">
        <span class="stage-month-label">Month ${monthLabel}</span>
        <strong class="stage-image-label">${item.label}</strong>
      </div>
    `;
    imageWrapper.appendChild(card);
  });

  container.appendChild(imageWrapper);
}

const RESULTS_TIMELINE = {
  monthExpectation: [
    {
      month:      "Month 1-2",
      heading:    "Improve Follicular Health, Control Dandruff",
      subheading: "Improve Follicular Health, Control Dandruff",
      image:      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/expectation_month_1.webp?v=1771501719",
      milestone:  false
    },
    {
      month:      "Month 3",
      heading:    "Hair Fall Control",
      subheading: "Hair Fall Control",
      image:      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/expectation_month_2.webp?v=1771501734",
      milestone:  true
    },
    {
      month:      "Month 4-5",
      heading:    "Hair Fall Growth",
      subheading: "Hair Fall Growth",
      image:      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/expectation_month_3.webp?v=1771501748",
      milestone:  false
    },
    {
      month:      "Month 6",
      heading:    "Maintaining Awesome Hair",
      subheading: "Maintaining Awesome Hair",
      image:      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/expectation_month_4.webp?v=1771501759",
      milestone:  false
    }
  ]
};
const TIMELINE_VARIANTS = {
  stop_hairfall_dandruff: {
    heading: "Improve Follicular Health, Control Dandruff",
    showGoal: true
  },
  stop_hairfall_no_dandruff: {
    heading: "Improve Internal Health, Follicular Health",
    showGoal: true
  },
  regrowth_dandruff: {
    heading: "Improve Follicular Health, Control Dandruff",
    showGoal: false
  },
  regrowth_no_dandruff: {
    heading: "Improve Internal Health, Follicular Health",
    showGoal: false
  }
};
function getTimelineVariant(data) {
  const cohort = (data.stage1Cohort || '').toLowerCase();

  switch (cohort) {
    case 'dandruff_stop_hairfall':
      return TIMELINE_VARIANTS.stop_hairfall_dandruff;

    case 'no_dandruff_stop_hairfall':
      return TIMELINE_VARIANTS.stop_hairfall_no_dandruff;

    case 'dandruff_regrow':
      return TIMELINE_VARIANTS.regrowth_dandruff;

    case 'no_dandruff_regrow':
      return TIMELINE_VARIANTS.regrowth_no_dandruff;

    default:
      return TIMELINE_VARIANTS.stop_hairfall_dandruff;
  }
}
function sectionMonthsExpectation(variantKey = 'monthExpectation', data) {
  const timeline  = RESULTS_TIMELINE[variantKey];
  const container = document.getElementById('month-expectation');

  if (!container || !timeline?.length) return;

  container.innerHTML = '';

  const fragment = document.createDocumentFragment();

  // ✅ compute once
  const variant = getTimelineVariant(data);

  timeline.forEach((month) => {

    const updatedHeading =
      month.month === "Month 1-2"
        ? variant.heading
        : month.heading;

    const block = document.createElement('div');

    block.className = `month-expectation-block${
      (variant.showGoal && month.milestone) ? ' milestone' : ''
    }`;

    block.innerHTML = `
      ${month.milestone && variant.showGoal ? `
        <div class="month-milestone-badge">
          Goal
        </div>
      ` : ''}
      
      <div class="month-expectation-content">
        <span class="month-expectation-month">${month.month}</span>
        <p class="month-expectation-title">${updatedHeading}</p>
      </div>

      <div class="month-expectation-block-image">
        <img 
          src="${month.image}" 
          alt="${updatedHeading}" 
          width="100"
          height="100"
          loading="lazy"
        />
      </div>
    `;

    // ✅ THIS WAS MISSING
    fragment.appendChild(block);
  });

  container.appendChild(fragment);
}

// functionality for real stories
const SKIP_URLS = [
  'https://d3twoz8hvcdm9h.cloudfront.net/App/Home/result/maleSuccessStories/new/stage1_2.webp'
];

function sectionRealStories(response) {
  let { successStories } = response;
  if (successStories.showComponent == true) {
    const imgCarousel     = document.querySelector('.image-carousel');
    const titleElement    = document.querySelector('.stories-main-heading');
    const subTitleElement = document.querySelector('.stories-sub-heading');
    titleElement.textContent    = successStories.title;
    subTitleElement.textContent = successStories.subTitle;

    successStories.stories.forEach((storyUrl) => {
      if (SKIP_URLS.includes(storyUrl.imageUrl)) return; // ← skip and move to next

      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl.imageUrl}" alt="Success Story" height="auto" width="auto">
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}
// end of functionality for real stories

// ============================================================
// DISCOUNT — APPLY 1-MONTH DISCOUNT
// ============================================================
function applyOneMonthDiscount(response) {
  const cartTotal = Math.round(response.cart_price);
  const strikeoutPrice = cartTotal + 500;

  // Default prices (no discount)
  document.querySelectorAll('.total-price').forEach(el => { el.innerHTML = `₹ ${cartTotal}`; });
  document.querySelectorAll('.strike-cart-total-price').forEach(el => { el.innerHTML = `₹ ${strikeoutPrice}`; });
  const stickySlash = document.getElementById('sticky-slash-price');
  if (stickySlash) stickySlash.innerHTML = `₹ ${strikeoutPrice}`;

  // Now check if discount applies
  const discountsData = response?.discounts;
  if (!discountsData?.discountValidityByPlan?._1Month) return;

  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;

  const { code, value, validCartValue, type } = discountObj;
  if (!code || !value || !validCartValue) return;
  if (cartTotal < validCartValue) return;

  const discountAmount  = type === 'percentage' ? Math.round((cartTotal * value) / 100) : value;
  const discountedTotal = Math.max(cartTotal - discountAmount, 0);
  const discountedStrike = discountedTotal + 500;

  document.querySelectorAll('.total-price').forEach(el => { el.innerHTML = `₹ ${discountedTotal}`; });
  document.querySelectorAll('.strike-cart-total-price').forEach(el => { el.innerHTML = `₹ ${discountedStrike}`; });
  if (stickySlash) stickySlash.innerHTML = `₹ ${discountedStrike}`;
  document.querySelectorAll('.refferal-discount-applied').forEach(el => el.classList.remove('d-none'));

  window.appliedReferralCode = code;
}
// ============================================================
// FUTURE KIT ROUTINE
// ============================================================
function FutureKitRoutine(maxMonths) {
  const section = document.querySelector('[id^="future-kit-routine-"]');
  if (!section) return;

  const images = FUTURE_KIT_IMAGES[maxMonths];
  if (!images) { console.warn('FutureKitRoutine: invalid maxMonths', maxMonths); return; }

  section.querySelector('.future-kit-img--desk').src = images.desk;
  section.querySelector('.future-kit-img--mob').src  = images.mob;
}

// ============================================================
// META / CAPI TRACKING
// ============================================================
function trackMetaEvent(userData, eventName) {
  const getCookieValue = name => {
    const match = document.cookie.split(';').find(c => c.trim().startsWith(name + '='));
    return match ? match.trim().split('=').slice(1).join('=') : null;
  };

  fetch(`${publicBase}tracking`, {
    method: 'POST',
    headers: AUTH_HEADERS,
    body: JSON.stringify({
      eventName,
      eventTime: Date.now(),
      email:     userData.email,
      phone:     userData.phone,
      fbc:       getCookieValue('_fbc'),
      fbp:       getCookieValue('_fbp'),
      url:       window.location.href,
      domain:    'traya.health',
      gender:    userData.gender,
    }),
  });
}

// ============================================================
// GA4 CART DATA
// ============================================================
function cartData() {
  window.dataLayer = window.dataLayer || [];
  const gtag = (...args) => window.dataLayer.push(args);

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      gtag('js', new Date());
      gtag('config', 'G-KJK84KP0LJ');
      gtag('event', 'view_cart', {
        currency: cart.currency,
        value:    parseInt(cart.items_subtotal_price) / 100,
        items:    cart.items.map(item => ({
          item_id:       item.id,
          item_name:     item.title,
          item_brand:    'Traya Health',
          item_category: '',
          price:         parseInt(item.price) / 100,
          quantity:      item.quantity,
        })),
      });
    })
    .catch(err => console.error('cartData error:', err));
}

// ============================================================
// CART ATTRIBUTE UPDATER (UTM + syntheticId) — with retry limit
// ============================================================
function scheduleCartAttributeUpdate() {
  const attributes = {};

  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('utm_')) {
      const v = localStorage.getItem(key);
      if (v) attributes[key] = v;
    }
  });

  const syntheticId = getParam('syntheticId') || getParam('id') || localStorage.getItem('syntheticId');
  if (syntheticId) {
    attributes.syntheticId = syntheticId;
    try { localStorage.setItem('syntheticId', syntheticId); } catch (e) {}
  }

  if (!Object.keys(attributes).length) return;

  function attempt(retries = 0) {
    if (retries >= 10) { console.warn('Cart attribute update gave up after 10 retries'); return; }

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count > 0) {
          return fetch('/cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ attributes }),
          })
            .then(r => r.json())
            .then(updated => console.log('Cart attributes updated:', updated.attributes));
        } else {
          setTimeout(() => attempt(retries + 1), 1000);
        }
      })
      .catch(err => console.error('scheduleCartAttributeUpdate error:', err));
  }

  attempt();
}

// ============================================================
// TAB SWITCHER (for .f-b-main-li nav)
// ============================================================
function triggerTabAction(target) {
  document.querySelectorAll('.nav-link').forEach(link => {
    link.classList.toggle('active', link.getAttribute('data-targets') === target);
  });
  document.querySelectorAll('.tab-pane').forEach(tab => {
    const isActive = tab.getAttribute('data-targets') === target;
    tab.classList.toggle('active', isActive);
    tab.classList.toggle('show',   isActive);
  });
}

// ============================================================
// LANGUAGE SELECTOR (header)
// ============================================================
function headerLanguageSelector() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const currentPage = params.get("page");

  if (!id) return;

  const langMap = {
    english: "_l_english",
    telugu: "_l_telugu",
    tamil: "_l_tamil"
  };

  const baseUrls = {
    english: "https://traya.health/pages/result4",
    telugu: "https://result.traya.health/pages/result4",
    tamil: "https://result.traya.health/pages/result4"
  };

  // Decide allowed languages
  let allowedLangs = ["english", "telugu", "tamil"];

  if (currentPage === "_l_telugu") {
    allowedLangs = ["english", "telugu"];
  } else if (currentPage === "_l_tamil") {
    allowedLangs = ["english", "tamil"];
  }

  const headerLanguageIcon = document.getElementById("language-icon-toggle");
  const headerLanguageDropdown = document.getElementById("language-dropdown-toggle");
  const headerWrapper = document.querySelector(".icons-flex-container");

  if (!headerLanguageDropdown) return;

  // ✅ SHOW ICON ONLY FOR TELUGU / TAMIL
  if (headerLanguageIcon) {
    if (currentPage === "_l_telugu" || currentPage === "_l_tamil") {
      headerLanguageIcon.classList.remove("d-none");
    } else {
      headerLanguageIcon.classList.add("d-none");
    }
  }

  // Update links + filter languages
  document.querySelectorAll("#language-dropdown-toggle .language-option").forEach(link => {
    const lang = link.getAttribute("hreflang");
    const pageParam = langMap[lang];
    const baseUrl = baseUrls[lang];

    if (!allowedLangs.includes(lang)) {
      link.style.display = "none";
      return;
    }

    link.style.display = "block";

    if (pageParam && baseUrl) {
      link.href = `${baseUrl}?id=${id}&page=${pageParam}`;
    }
  });

  // Dropdown toggle logic
  const langBtn = document.querySelector('.language-icon-toggle');
  const arrowIcon = document.querySelector('.language-arrow-icon');
  const langDropdown = document.querySelector('.language-dropdown');

  langBtn?.addEventListener('click', () => {
    langDropdown?.classList.toggle('open');
    langBtn.classList.toggle('white-background');
    arrowIcon?.classList.toggle('rotate');
  });

  headerLanguageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    headerLanguageDropdown.classList.toggle("hidden");
    headerWrapper?.classList.toggle("hidden-dropdown");
  });
}

// ============================================================
// ELIGIBILITY CHECK UI
// ============================================================
function checkEligibility() {
  document.querySelector('.checking-container').style.display = 'none';
  document.querySelector('.loading-container').style.display  = 'flex';
  setTimeout(() => {
    document.querySelector('.loading-container').style.display = 'none';
    document.querySelector('.eligibilty-result').style.display = 'block';
  }, 1000);
}